import React, { useCallback, useEffect } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { Helmet } from "altus-ui-components";

import {
  getCourseExpiryReport,
  clearCourseExpiryReport,
  courseExpiryReportOnLoad,
  courseExpiryReportOnUnload,
  downloadAndSaveCourseExpiryReport,
} from "features/competence.actions";

import { getCourseExpiryReportFromState } from "features/competence.selectors";

import { ACTIONS, APP_ROOT, EMPTY_MAP } from "app/app.constants";
import { getSummarizedDataStatesFromState } from "app/app.selectors";
import GapReportBasePage from "features/components/GapReport/GapReportBasePage";
import CourseExpiryReportFilter from "features/reports/courseExpiryReport/CourseExpiryReportFilter"; // FILTERS,
import CourseExpiryReportTableContainer from "features/reports/courseExpiryReport/CourseExpiryReportTableContainer";

const CourseExpiryReport = ({
  root = APP_ROOT.HR,
  dataState,
  breadcrumb,
  dispatchOnLoad,
  dispatchOnUnload,
  dispatchGetReport,
  employeesByDepartment = EMPTY_MAP,
  dispatchClearReport,
  dispatchDownloadGapReport,
}) => {
  useEffect(() => {
    dispatchOnLoad();
    return () => dispatchOnUnload();
  }, [dispatchOnLoad, dispatchOnUnload]);

  const renderFilter = useCallback(
    () => (
      <CourseExpiryReportFilter
        getGapReport={dispatchGetReport}
        clearGapReport={dispatchClearReport}
        downloadGapReport={dispatchDownloadGapReport}
      />
    ),
    [dispatchGetReport, dispatchClearReport, dispatchDownloadGapReport],
  );

  return (
    <>
      <Helmet titleTemplate="%s">
        <title>{breadcrumb}</title>
      </Helmet>
      <GapReportBasePage
        title={breadcrumb}
        dataState={dataState}
        renderFilter={renderFilter}
        employeesByDepartment={employeesByDepartment}
      >
        {!!employeesByDepartment.size && (
          <CourseExpiryReportTableContainer
            root={root}
            title={breadcrumb}
            courses={employeesByDepartment}
          />
        )}
      </GapReportBasePage>
    </>
  );
};

export default compose(
  connect(
    state => ({
      employeesByDepartment: getCourseExpiryReportFromState(state),

      dataState: getSummarizedDataStatesFromState(
        state,
        ACTIONS.GET_COURSE_EXPIRY_REPORT,
        ACTIONS.DOWNLOAD_COURSE_EXPIRY_REPORT,
      ),
    }),
    {
      dispatchOnLoad: courseExpiryReportOnLoad,
      dispatchGetReport: getCourseExpiryReport,
      dispatchOnUnload: courseExpiryReportOnUnload,
      dispatchClearReport: clearCourseExpiryReport,
      dispatchDownloadGapReport: downloadAndSaveCourseExpiryReport,
    },
  ),
  React.memo,
)(CourseExpiryReport);
